import {
  ButtonProps,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';
import CloseableDialogTitle from './ClosableDialogTitle';
import { Button } from '../../../interaction/Buttons/Default Button/Button';
import { getDialogContainer } from '../../../../react-components/dialog-forms/utils/dialog-container';

export type DialogAction = {
  text: string;
  buttonColor?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
  isPrimary?: boolean;
  callback: (args) => void;
  disabled?: boolean;
};

export type BaseDialogProps = {
  title?: string;
  actions?: DialogAction[];
};

type DialogProps = BaseDialogProps & {
  open: boolean;
  setOpen: (open: boolean) => void;
  children: JSX.Element | React.ReactNode;
  zIndex?: number;
  disableBackdropClick?: boolean;
};

export const BaseDialog = ({
  title,
  actions,
  open,
  setOpen,
  children,
  zIndex,
  disableBackdropClick,
}: DialogProps) => {
  const container = getDialogContainer();

  const handleClose = (event: object, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick' && disableBackdropClick) {
      return;
    }
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      container={container}
      sx={zIndex ? { zIndex } : undefined}
    >
      <CloseableDialogTitle title={title} handleClose={() => setOpen(false)} />
      <DialogContent>{children}</DialogContent>
      {actions?.length > 0 && (
        <DialogActions>
          {actions.map(action => {
            const color = action.buttonColor ? action.buttonColor : 'primary';
            const variant = action.isPrimary ? 'contained' : 'text';
            return (
              <Button
                key={action.text}
                color={color as ButtonProps['color']}
                variant={variant}
                onClick={action.callback}
                disabled={action.disabled}
              >
                {action.text}
              </Button>
            );
          })}
        </DialogActions>
      )}
    </Dialog>
  );
};
